import { Component, OnInit, ViewChild, SecurityContext } from '@angular/core';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import {
  MatDialog
} from '@angular/material/dialog';


import { CasedialogComponent } from '../casedialog/casedialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { CompName, constantStrings, EventType, statusCode, STATUSCODESTRING } from '@shared/helpers/constants';
import { CasedashboardService } from '../casedashboard.service';
import { CaseHistoryData, errorResponse } from '@shared/models/user.model';
import { Router } from '@angular/router';
import { SharedStateService } from '@shared/services/shared-state.service';
import { HeaderComponent } from '../header/header.component';
import { caseHistoryElement } from '../interface/casehistory.interface';
import { AuthService } from '@shared/services/auth.service';
import { environment } from '@environments/environment';
import { ProjectActionsRequestService } from '@viewer/services';
import { AlertDialogService } from '@shared/alert-dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-casehistory',
  templateUrl: './casehistory.component.html',
  styleUrls: ['./casehistory.component.scss'],
})
export class CaseHistoryComponent implements OnInit {
  displayedColumns: string[] = [
    'icons',
    'caseId',
    'anatomy',
    'imagingType',
    'caseStatus',
    'claimantFirstName',
    'updateDateTime',
    'dueDateTime',
    'reviewTime',
    'actionsView'
  ];

  dataSource = new MatTableDataSource<caseHistoryElement>();
  statusRejected = STATUSCODESTRING.statusRejected;
  statusApproved = STATUSCODESTRING.statusApproved;
  statusError = STATUSCODESTRING.statusError;
  errorInCaseHistoryDetails: any;
  caseHistoryDetailsRes: any;
  caseHistoryData: CaseHistoryData;
  searchText: any;
  pagelimit: number;
  selectedRowIndex: any;
  storeCaseHistoryData: any;
  caseCount: number;
  errorRes: errorResponse;
  displaySpinner: boolean = true;
  caseId: any;
  loggedInUser: any;
  totalRec: number = 0;
  totalPages: any;
  auditAction: any;
  errUserDetails: any;
  actionActivityDetails: any;
  expandTable: boolean = false;
  isDisabled: boolean;
  errOutcome: number = 0;
  successOutcome: number = 1;
  eventOutcome: number;
  compName: string = CompName.CASEHISTORY;
  sortBy: string;
  sortOrder: SortDirection;
  pageNumberTemp=1;

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    public dialog: MatDialog,
    private casedashboardService: CasedashboardService,
    private router: Router,
    private sharedState: SharedStateService,
    private authService: AuthService,
    private projectActionsRequestService: ProjectActionsRequestService,
    private alertDialogService: AlertDialogService,
    private sanitizer: DomSanitizer
  ) { }
  public showCaseModal: boolean = false;
  selection = new SelectionModel<any>(false, []);
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(HeaderComponent) filterBanner;

  ngOnInit(): void {
    //To get user actions from json file
    this.sharedState.userActionStateData$.subscribe(response => {
      this.auditAction = response;
    });
    this.pagelimit = constantStrings.PageLimit;
    this.caseHistoryData = {
      page: 0,
      limit: this.pagelimit,
      column: 'updatedDate',
      sortOrder: 'DESC',
      searchText: '',
      anatomy: [],
      sourceFacilityId: [],
      caseStatus: [10, 11, 4, 17, 18, 19, 21, 22, 23],
      claimantUserName: [],
      imagingType: [],
      fromDueDate: null,
      toDueDate: null,
      fromUpdatedDate: null,
      toUpdatedDate: null
    }
    this.getCaseHistoryDetails(this.caseHistoryData);
  }
  ngAfterViewInit() {
    this.dataSource.sort = null;
  }
  ngAfterViewChecked() {
    if (this.filterBanner.filterActive) {
      this.expandTable = true;
    } else {
      this.expandTable = false;
    }
  }
  /**
   * The function announces the sorting state of a table using the Angular LiveAnnouncer.
   * @param {Sort} sortState - Sort object that contains information about the current sorting state,
   * including the sorting direction.
   */
  sortTable(sortState: Sort) {
    this.sortBy = sortState.active;
    this.sortOrder = sortState.direction;
    this.caseHistoryData.column=sortState.active;
    this.caseHistoryData.sortOrder=sortState.direction;
    const columnNameDB = { 'caseStatus' : 'caseHistoryUploadStatus', 'claimantFirstName' : 'claimantFirstName',
    'updateDateTime' : 'updatedDate','dueDateTime' : 'dueDate','reviewTime' : 'reviewTime'
     }
     this.caseHistoryData.column=columnNameDB[sortState.active];
    //this.caseHistoryData.page=0;
    this.getCaseHistoryDetails(this.caseHistoryData);
  }
  /**
   * The function opens a dialog box to display case details and waits for the dialog to close.
   */
  viewCaseDetails(rowData): void {
    let dialogRef = this.dialog.open(CasedialogComponent, {
      autoFocus: false,
      id: 'caseDetails',
      disableClose: true,
      data: { id: rowData.caseId, status: rowData.caseStatus, faciltyId: rowData.sourceFacilityId},
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }
  /**
   * This function retrieves case history details from a service and updates the data source
   * accordingly.
   * @param params - The parameters passed to the function `getCaseHistoryDetails()`. It is not
   * specified in the code snippet what these parameters are.
   */
  getCaseHistoryDetails(params) {
    this.displaySpinner = true;
    params.page=0;
    this.casedashboardService.getCaseDashboardDetails(params).subscribe(
      {
        next: Response => {
          let result = Response;
          this.displaySpinner = false;
          this.caseCount = 0;
          this.totalRec = 0;
          this.caseHistoryDetailsRes = result;
          this.totalPages = result.totalPages;
          if (result.dashboardDetails != undefined) {
            for (let items of result.dashboardDetails) {
              items.reviewTime = this.convertSecondstoTime(items.reviewTime);                
              items['claimantFirstName'] = items.claimantUserName != null ? items.claimantFirstName.toUpperCase()+" "+ items.claimantLastName.toUpperCase() : ''; 
              if(items.caseStatus === STATUSCODESTRING.statusUploadedToMic || items.caseStatus === STATUSCODESTRING.statusOnTablet || items.caseStatus === STATUSCODESTRING.statusCaseComplete || items.caseStatus === STATUSCODESTRING.statusCaseFailed || items.caseStatus === STATUSCODESTRING.statusUploadPending || items.caseStatus === STATUSCODESTRING.statusCaseCancel) {
                items['caseStatus'] = this.statusApproved;
              }             
            }
          }
          if (this.caseHistoryData.page == 0) {
            this.storeCaseHistoryData = result.dashboardDetails;
          } else {
            this.storeCaseHistoryData = [...this.storeCaseHistoryData, ...result.dashboardDetails]
          }   
          this.dataSource.data = this.storeCaseHistoryData;
          if (result.dashboardDetails != null && result.dashboardDetails.length) {
            this.totalRec = this.storeCaseHistoryData.length;
            this.caseCount = this.totalRec;
          }
        },
        error: error => {
          this.errorInCaseHistoryDetails = error;
          this.displaySpinner = false;
        }
      });
  }
  /**
   * The function increments the page number and retrieves case history details with a search text
   * parameter.
   */
  showMore() {
    this.pageNumberTemp = this.pageNumberTemp + 1;
    this.caseHistoryData.limit= (this.pageNumberTemp) * 25;
    this.caseHistoryData.searchText = this.searchText;
    this.getCaseHistoryDetails(this.caseHistoryData);
  }
  highlightRow(row) {
    this.selectedRowIndex = row.caseId;
  }
  /**
   * The function searches for a case status or text and retrieves the case history details.
   */
  search(txt) {
    this.searchText = txt;
    this.caseHistoryData.searchText = this.searchText;
    this.caseHistoryData.page = 0;
    this.getCaseHistoryDetails(this.caseHistoryData);
  }
  /**
   * The function updates the case status based on whether an error checkbox is checked or not and
   * retrieves case history details.
   */
  searchIconClick(checked) {
    this.caseHistoryData.page = 0;
    this.caseHistoryData.caseStatus = [];
    if (checked.isErrorChecked) {
      this.caseHistoryData.caseStatus.push(statusCode.REJECTED, statusCode.ERROR);
    } else {
      this.caseHistoryData.caseStatus = [10, 11, 4, 17, 18, 19, 21, 22, 23];
    }
    this.getCaseHistoryDetails(this.caseHistoryData);
  }
  /**
   * The function navigates to a patient viewer page for a specific case ID and logs an audit activity
   * with a success outcome.
   */
  async navigateMRI(caseid: string) {
    this.openMRI(caseid);
    return;
    
    /* As part of PRSEG-416 Hash validation is stopped for all cases */
    const DEFAULT_SSM_VALUE: string = 'false';
    const IS_DISABLE_HIL_INTEGRITY: string = await this.authService.getSSMValue(environment.ssmParams.DISABLE_HIL_VALIDATION);

    if (IS_DISABLE_HIL_INTEGRITY === DEFAULT_SSM_VALUE) {
      this.validateHashByCaseId(caseid);
    } else {
      this.openMRI(caseid);
    }
  }

  openMRI(caseId: string): void {
    this.caseId = caseId;
    localStorage.setItem("caseId",caseId);
    this.router.navigate([caseId, 'patientviewer']);
    this.auditLogActivity(this.successOutcome, EventType.read, this.auditAction.UserActions.caseViewMode);
  }

  validateHashByCaseId(caseId: string): void {
    const STATUS_CODE: string = '200';

    this.projectActionsRequestService.validateHash(caseId).subscribe((res) => {
      if (res.responseStatus === STATUS_CODE) {
        this.openMRI(caseId);
      } else {
        this.alertDialogService.openConfirmDialog('Dialog.HASH_VERIFICATIN_FAILED', 'Dialog.ConfirmButtons.OK');
      }
    });
  }

  /**
   * This function loads filter data and retrieves case history details based on the provided parameters.
   * @param caseData - an object containing various filters for the case history data. The available
   * filters are:
   */
  loadFilterData(caseData) {
    this.caseHistoryData.page = 0;
    this.caseHistoryData.anatomy = caseData.anatomy; 
    this.caseHistoryData.caseStatus = caseData.caseStatus.length >0 ? caseData.caseStatus : [];     
    if (this.caseHistoryData.caseStatus.includes(10)) {
      const statusesToAdd = [17, 18, 19, 21, 22, 23];

      statusesToAdd.forEach(status => {
        if (!this.caseHistoryData.caseStatus.includes(status)) {
          this.caseHistoryData.caseStatus.push(status);
        }
      });
    } else if (!this.caseHistoryData.caseStatus.includes(10)) {
      let values = [17, 18, 19, 21, 22, 23];
      this.caseHistoryData.caseStatus = this.caseHistoryData.caseStatus.filter(item => !values.includes(item));         
    }    
    if (this.caseHistoryData.caseStatus.length <= 0) {
      this.caseHistoryData.caseStatus =  [10, 11, 4, 17, 18, 19, 21, 22, 23];
    }
    this.caseHistoryData.claimantUserName = caseData.claimantUserName;
    this.caseHistoryData.fromDueDate = caseData.fromDueDate;
    this.caseHistoryData.fromUpdatedDate = caseData.fromUpdatedDate;
    this.caseHistoryData.imagingType = caseData.imagingType;
    this.caseHistoryData.sourceFacilityId = caseData.sourceFacilityId;
    this.caseHistoryData.toDueDate = caseData.toDueDate;
    this.caseHistoryData.toUpdatedDate = caseData.toUpdatedDate;
    this.getCaseHistoryDetails(this.caseHistoryData);
  }
  /**
   * This function exports an audit log as a CSV file and logs the activity.
   */
  public exportAuditLogAPI(params): any {
    this.casedashboardService.exportAuditLogService(params).subscribe({
      next: Response => {
        let result = Response;
        this.auditLogActivity(constantStrings.AUDITLOGEXPORT, EventType.read, this.auditAction.UserActions.caseLogDownload);
        const blob = new Blob([Response], { type: 'text/csv;encoding:utf-8' });
        const url = window.URL.createObjectURL(blob);
        const SANITIZED_URL = this.sanitizer.sanitize(SecurityContext.URL, url) as string;
        const a = document.createElement('a');
        a.setAttribute('href', SANITIZED_URL);
        a.setAttribute('download', params + constantStrings.AUDITLOGEXPORT);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      error: error => {
        this.auditLogActivity(constantStrings.AUDITLOGEXPORT, EventType.read, this.auditAction.UserActions.sysException);
        this.errorRes = error;
      }
    })
  }
  /**
   * This function exports an audit log for a given case ID and enables a button.
   */
  public exportLog(caseId) {
    this.isDisabled = false;
    this.exportAuditLogAPI(caseId);
  }
  /**
   * This function logs an audit activity with details such as case ID, user information, date and time,
   * action, event type, and outcome.
   */
  auditLogActivity(outcome, eventName, actionName) {
    let auditLogTime = new Date();
    this.eventOutcome = outcome;
    let action = {
      "caseId": this.caseId ? this.caseId : '',
      "userName": this.casedashboardService.loggedInUserName,
      "dateTime": auditLogTime,
      "action": actionName,
      "eventOutCome": this.eventOutcome ? 1 : 0,
      "eventType": eventName
    };
    this.casedashboardService.auditLogActivity(action).subscribe({
      next: Response => {
        let result = Response;
        this.actionActivityDetails = result;
      },
      error: error => {
        this.errUserDetails = error;
      }
    })
  }
  convertSecondstoTime(secVal) {
    const totalMs = secVal * 1000; 
    const result = new Date(totalMs).toISOString().slice(11, 19); 
    return result;
  }
}
